module.exports = __webpack_public_path__ + "static/media/Portrait-10190.1add76a9.jpg";